import {
  ISalePageDetailResponseProduct,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { Checkbox } from '@/components';
import { Element } from '@vuddy/components';
import clsx from 'clsx';
import { PurchaseItemContent } from '../common/PurchaseItemContent';
import { disabledItem } from '../common/bottom.css';

interface PurchaseCheckItemProps {
  item: ISalePageDetailResponseProduct &
    ISalePageProductAdditionalInformResponse;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  hasVerificationCode?: boolean;
  verificationCodeName?: string;
  onCodeInputClick?: () => void;
  compact?: boolean;
}

export const PurchaseCheckItem = ({
  item,
  checked = false,
  onChange,
  hasVerificationCode,
  verificationCodeName,
  onCodeInputClick,
  compact = false,
}: PurchaseCheckItemProps) => {
  const isPurchaseLimited =
    !item.isPurchasable && item.remainingPurchaseCount === 0;
  const disabled = item.saleStatus !== 'ON_SALE' || isPurchaseLimited;

  return (
    <Element
      padding={compact ? 'padding_base' : undefined}
      paddingY={compact ? undefined : 'padding_small'}
      className={clsx(disabled && disabledItem)}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        gap="gap_xl"
        alignItems="flex-start">
        <PurchaseItemContent
          item={item}
          hasVerificationCode={hasVerificationCode}
          verificationCodeName={verificationCodeName}
          onCodeInputClick={onCodeInputClick}
        />
      </Checkbox>
    </Element>
  );
};
